import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export const sleep = timeout =>
  new Promise(resolve => {
    setTimeout(() => resolve(undefined), timeout);
  });

export const toastAlert = async (msg, autoClose = 1500, form = 'success', isTheme = true) => {
  await sleep(300);
  switch (form) {
    case 'success':
      toast.success(msg, { autoClose: autoClose, theme: isTheme ? 'colored' : 'auto' });
      break;
    case 'error':
      toast.error(msg, { autoClose: autoClose, theme: isTheme ? 'colored' : 'auto' });
      break;
    case 'info':
      toast.info(msg, { autoClose: autoClose, theme: isTheme ? 'colored' : 'auto' });
      break;
    case 'warning':
      toast.warning(msg, { autoClose: autoClose, theme: isTheme ? 'colored' : 'auto' });
      break;
    default:
      toast(msg, { autoClose: autoClose, theme: 'auto' });
      break;
  }
};

export const customToast = async (message, autoClose) => {
  await sleep(500);
  await toastAlert(message, autoClose);
};
